import React from 'react';
import TabbedNodeEditor from './NodeEditor';
import EdgeEditor from './EdgeEditor';
import ValidationPanel from './ValidationPanel';
import SurveySettings from './SurveySettings';

const PredicateEditor = ({
  surveyData,
  selectedNode,
  selectedEdge,
  onSurveyDataChange,
  onNodeUpdate,
  onEdgeUpdate,
  onDeleteEdge,
  edgeValidation,
  fullValidationResults,
  nodes,
  edges,
  onShowNotification,
  onHighlightNode,
  onJump,
  undockedPanels = new Set(),
  onUndock
}) => {
  const hasValidationErrors = fullValidationResults && Object.keys(fullValidationResults).length > 0;
  const isSurveySettingsUndocked = undockedPanels.has('survey-settings');
  const isFlowValidationUndocked = undockedPanels.has('flow-validation');
  const isEdgeEditorUndocked = undockedPanels.has('edge-editor');

  return (
    <div className="predicate-editor">
      <h3>Edit Properties</h3>

      {!isSurveySettingsUndocked && (
        <SurveySettings
          surveyData={surveyData}
          onSurveyDataChange={onSurveyDataChange}
          nodes={nodes}
          onJump={onJump}
          sectionId="survey-settings"
          onUndock={onUndock}
        />
      )}

      {hasValidationErrors && !isFlowValidationUndocked && (
        <ValidationPanel
          edgeValidation={edgeValidation}
          fullValidationResults={fullValidationResults}
          nodes={nodes}
          onJump={onJump}
          sectionId="flow-validation"
          onUndock={onUndock}
        />
      )}

      {selectedNode ? (
        <TabbedNodeEditor
          node={selectedNode}
          onNodeUpdate={onNodeUpdate}
          validationErrors={fullValidationResults?.[selectedNode.id]}
          nodes={nodes}
          edges={edges}
          undockedPanels={undockedPanels}
          onUndock={onUndock}
        />
      ) : selectedEdge ? (
        !isEdgeEditorUndocked && (
          <EdgeEditor
            edge={selectedEdge}
            onEdgeUpdate={onEdgeUpdate}
            onEdgeDelete={onDeleteEdge}
            validation={edgeValidation}
            nodes={nodes}
            edges={edges}
            sectionId="edge-editor"
            onUndock={onUndock}
          />
        )
      ) : (
        <div className="no-selection-wrapper">
          <div className="no-selection">
            <p>Select a node or edge to edit its properties</p>
            <p><small>Double-click on the canvas to add a new question</small></p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PredicateEditor;
